<template>
  <div class="breadcrumbs h5 cl-gray" v-if="paths">
    <span v-for="link in paths" :key="link.route_link">
      <router-link :to="link.route_link" class="link">
        {{ link.name | htmlDecode }}
      </router-link> <span class="slash">/</span>
    </span>
    <span class="cl-mine-shaft">
      {{ current | htmlDecode }}
    </span>
  </div>
</template>

<script>
import { localizedRoute, currentStoreView } from '@vue-storefront/core/lib/multistore'
import i18n from '@vue-storefront/i18n'
import { mapGetters, mapActions } from 'vuex'


export default {
  computed: {
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation',
      currentPartner: 'partners/getCurrentPartner'
    }),
    paths () {
      if (this.currentLocation && this.currentCategory && this.currentTag) {
        return [
          {name: i18n.t('All Stores'), route_link: localizedRoute('/', currentStoreView().storeCode)},
          {name: this.currentLocation.name, route_link: `/${this.currentLocation.code}`},
          {name: this.currentCategory.title, route_link: `/${this.currentLocation.code}/${this.currentCategory.code}`}
        ]
      }

      if (this.currentLocation && this.currentCategory) {
        return [
          {name: i18n.t('All Stores'), route_link: localizedRoute('/', currentStoreView().storeCode)},
          {name: this.currentLocation.name, route_link: `/${this.currentLocation.code}`}
        ]
      }

      if (this.currentLocation && this.currentPartner) {
        const routes = this.routes ? this.routes : this.$store.state.breadcrumbs.routes

        if (this.withHomepage) {
          return [
            {name: i18n.t('All Stores'), route_link: localizedRoute('/', currentStoreView().storeCode)},
            {name: this.currentLocation.name, route_link: `/${this.currentLocation.code}`},
            {name: this.currentPartner.title, route_link: this.currentPartner.route},
          ]
        }

        return routes
      } else {
        return false
      }
    },
    current () {
      if (this.currentTag) {
        return this.currentTag.title
      }
      if (this.currentCategory) {
        return this.currentCategory.title
      }
      return this.activeRoute || this.$store.state.breadcrumbs.current
    }
  },
  props: {
    routes: {
      type: Array,
      required: false,
      default: null
    },
    withHomepage: {
      type: Boolean,
      default: false
    },
    activeRoute: {
      type: String,
      default: ''
    },
    currentCategory: {
      type: Object,
      required: false,
      default: null
    },
    currentTag: {
      type: Object,
      required: false,
      default: null
    }
  }
}
</script>
<style lang="scss" scoped>
  .link {
    &:hover {
        text-decoration: underline;
     }
  }
</style>
<style>
  .breadcrumbs span:first-child a{
    font-weight: bold;
    font-family: 'TTNorms Bold', sans-serif;
  }
</style>
